var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 54,
    viewBox: "0 0 80 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4986 47.87C31.4644 55.9659 23.5374 54.8949 16.9273 48.211C13.4737 44.693 10.4739 40.759 7.99765 36.5001C5.21567 31.4191 2.89724 26.0991 1.07035 20.6043C-3.97782 7.66759 10.2581 3.00274 14.0915 1.51661C18.7228 0.487732 23.455 -0.0207481 28.1998 0.000682831C33.3533 0.0362549 38.4928 0.542465 43.5536 1.51297C53.0484 5.96335 58.9709 7.12011 55.128 20.6007C55.128 20.6007 52.9266 29.4963 48.876 36.4965C46.385 40.7666 43.2184 44.6072 39.4986 47.87Z",
    fill: "#B7B7F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7264 31.3798L43.0383 23.8676L31.0761 16.9613L30.7264 31.3798ZM29.3557 33.754C28.4868 33.2523 27.9614 32.3162 27.9857 31.3133L28.3355 16.8948C28.3589 15.9275 28.8906 15.0442 29.7343 14.5706C30.578 14.097 31.6089 14.1033 32.4469 14.5871L44.4091 21.4934C45.247 21.9772 45.7679 22.8669 45.7796 23.8344C45.7913 24.8019 45.2922 25.7039 44.4662 26.2079L32.1543 33.72C31.2979 34.2426 30.2245 34.2556 29.3557 33.754Z",
    fill: "#4F41F2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_9854",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 8,
    width: 49,
    height: 47
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7244 17.0407L38.8215 19.6753L59.5883 16.6069L68.5824 28.2877L63.6107 40.854L42.6288 43.5269L38.8215 33.7857L35.54 35.9152L31.4963 39.2639L31.1152 42.3145L44.0811 54.4044L71.0059 52.8706L80 23.5429L72.8317 8H42.626L34.7244 17.0407Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_9854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.9258 12.0334C48.5335 12.0369 44.2774 13.5584 40.8784 16.3403C37.4793 19.1221 35.1462 22.9933 34.2743 27.2982C33.4023 31.6031 34.0451 36.077 36.0937 39.9623C38.1423 43.8476 41.4708 46.9054 45.5155 48.6178C50.1689 50.5832 55.4124 50.6196 60.0926 48.7189C64.7728 46.8182 68.5062 43.1362 70.4716 38.4829C72.437 33.8295 72.4734 28.586 70.5727 23.9058C68.6721 19.2257 64.99 15.4922 60.3367 13.5268C57.992 12.5354 55.4714 12.0274 52.9258 12.0334ZM52.9258 9.65308C57.1622 9.65308 61.3035 10.9093 64.826 13.263C68.3485 15.6166 71.094 18.962 72.7152 22.8759C74.3364 26.7899 74.7606 31.0967 73.9341 35.2518C73.1076 39.4069 71.0676 43.2235 68.0719 46.2192C65.0763 49.2148 61.2596 51.2548 57.1046 52.0813C52.9495 52.9078 48.6427 52.4836 44.7287 50.8624C40.8147 49.2412 37.4694 46.4957 35.1158 42.9733C32.7621 39.4508 31.5059 35.3094 31.5059 31.073C31.5059 25.3921 33.7626 19.9438 37.7796 15.9268C41.7966 11.9098 47.2449 9.65308 52.9258 9.65308Z",
    fill: "#4F41F2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeSub);
export default __webpack_public_path__ + "static/media/change-sub.677ca4ae2d1ff268fbe837ba3fa6cae9.svg";
export { ForwardRef as ReactComponent };